import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';
import { ThemePalette } from 'mui.theme';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { CustomMuiThemeProvider } from 'theme/CustomMuiThemeProvider';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const GetProView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useAppSelector((state) => state.authReducer.customer.theme);
  const enableDarkTheme = isDarkTheme(theme);
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  return (
    <CustomMuiThemeProvider>
      <Box
        sx={{
          minHeight: 'calc(100vh - 64px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={0}
            sx={{
              p: 4,
              borderRadius: 3,
              textAlign: 'center',
              border: '1px solid',
              borderColor: enableDarkTheme
                ? 'rgba(255,255,255,0.12)'
                : 'divider',
            }}
          >
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 64,
                height: 64,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                color: '#fff',
                fontSize: '1.5rem',
                fontWeight: 700,
                mb: 2,
              }}
            >
              Pro
            </Box>
            <Typography variant="h4" fontWeight={600} gutterBottom>
              {t('get_pro')}
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {t(
                'unlock_advanced_features_and_insights_with_a_pro_subscriptio'
              )}
            </Typography>
            <Typography variant="body2" sx={{ mb: 3 }}>
              {t('contact_us_to_upgrade')}{' '}
              <Typography
                component="a"
                href="mailto:sales@symx.ai"
                sx={{
                  color: ThemePalette.typography.primary,
                  fontWeight: 600,
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                sales@symx.ai
              </Typography>
            </Typography>
            <Button
              variant="contained"
              size="large"
              sx={{
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                color: '#fff',
                '&:hover': {
                  background:
                    'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                },
              }}
              onClick={() => {
                navigate(-1);
              }}
            >
              {t('back_to_app')}
            </Button>
          </Paper>
        </Container>
      </Box>
    </CustomMuiThemeProvider>
    // null
  );
};
